<div mat-dialog-title>
    {{"CV_LOCATION.location_manager" |translate}}
    <span class="float-right pointer">
        <i class="fa fa-times " (click)="close()"></i>
    </span>
</div>
<div mat-dialog-content>
    <div class="row">
        <div class="col-md-12">
            <mat-form-field class="search_text">
                <!-- <app-google-search-autocomplete style="padding: 0;" class="searchTerm" (setAddress)="getAddress($event);" [adressType]="geocode" [(ngModel)]="google_search">
                </app-google-search-autocomplete> -->

                <input [(ngModel)]="google_search" type="search" (input)="setTimer()" matInput
                    [placeholder]="'CV_LOCATION.find_your_city_here'|translate" ngInit
                    [func]="getPlaceAutocompleteRefPresent" style="width: 100%;" #addresstext />
                <!-- <mat-icon matSuffix (click)="getPlaceByAddress()" class="pointer">search</mat-icon> -->
                <!-- <mat-icon matSuffix (click)="getCurrentLocation()" class="pointer" title="Your current location">
                    my_location
                </mat-icon> -->

            </mat-form-field>
        </div>
        <div class="col-md-12  table-responsive">
            <table class="table table-striped">
                <tr>
                    <th>City</th>
                    <td [title]="location.city">{{location.city}}</td>
                </tr>
                <tr>
                    <th>State</th>
                    <td [title]="location.state">{{location.state}}</td>
                </tr>
                <tr>
                    <th>Country</th>
                    <td [title]="location.country">{{location.country}}</td>
                </tr>
            </table>
        </div>
    </div>
</div>
<div mat-dialog-actions>
    <span style="font-size: 13px !important;" id="tm-popup-notification-window"> </span>

    <button style="min-width: 5rem;" class="ml-auto btn-sm  blob-btn-cancel btn mx-1 mx-1 tallite-action"
        (click)="close()">
        {{ 'BTN.cancel' | translate}}
        <span class="blob-btn-cancel__inner">
            <span class="blob-btn-cancel__blobs">
                <span class="blob-btn-cancel__blob"></span>
                <span class="blob-btn-cancel__blob"></span>
                <span class="blob-btn-cancel__blob"></span>
                <span class="blob-btn-cancel__blob"></span>
            </span>
        </span>
    </button>
    <button style="min-width: 5rem;" (click)="save()"
        class="blob-btn float-right btn   mx-1 float-right btn-sm tallite-action" type="submit">
        {{ 'BTN.ok' | translate }}
        <span class="blob-btn__inner">
            <span class="blob-btn__blobs">
                <span class="blob-btn__blob"></span>
                <span class="blob-btn__blob"></span>
                <span class="blob-btn__blob"></span>
                <span class="blob-btn__blob"></span>
            </span>
        </span>
    </button>
</div>